import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const ArrowLeft_sm = (props) => {
    const width = props.width ? props.width + 'px' : '20px';
    const height = props.height ? props.height + 'px' : '20px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 20 20"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.53033 4.46967C8.82322 4.76256 8.82322 5.23744 8.53033 5.53033L4.81066 9.25H17C17.4142 9.25 17.75 9.58579 17.75 10C17.75 10.4142 17.4142 10.75 17 10.75H4.81066L8.53033 14.4697C8.82322 14.7626 8.82322 15.2374 8.53033 15.5303C8.23744 15.8232 7.76256 15.8232 7.46967 15.5303L2.46967 10.5303C2.17678 10.2374 2.17678 9.76256 2.46967 9.46967L7.46967 4.46967C7.76256 4.17678 8.23744 4.17678 8.53033 4.46967Z"
            />

        </SvgStyled>
    );
};

export default ArrowLeft_sm;
